import React from "react";
import { Form } from "semantic-ui-react";
import { errorsWithPrefix } from "./utils";
import Address from './Address';
import { useExtLabels } from './extLabels'

const Invoice = ({ model, errors = {}, onChange, disabled }) => {
    const l = useExtLabels()

    const handleChange = target => onChange({ ...model, [target.name]: target.value });

    return (
        <React.Fragment>
            <h3>{l('Dane do faktury')}</h3>
            <Form.Input
                disabled={disabled}
                label={l("Nazwa")}
                name="name"
                value={model.name}
                onChange={({ target }) => handleChange(target)}
                required
                error={!!errors.name}
            />
            <Address
                model={model.address}
                errors={errorsWithPrefix(errors, 'address')}
                onChange={value => handleChange({ name: "address", value })}
            />
            <Form.Input
                disabled={disabled}
                label={l("NIP")}
                name="nip"
                value={model.invoiceNip}
                onChange={({ target }) => handleChange(target)}
                required
                pattern="^\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})$"
                error={!!errors.nip}
            />
        </React.Fragment>
    );
};

export default Invoice;